






































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import XLSX from "xlsx";
import moment from "moment";

@Component
export default class DataTableComponent extends Vue {
    @Prop() options!: any;
    @Prop() tableData!: any;
    @Prop() tableHeaders!: any;
    @Prop() filename!: string;
    @Prop() dynamicSlots!: any;
    @Prop() hideColumns!: boolean;
    @Prop({default:false}) loadingData!: boolean

    selectedItem=0;
    search: string = "";

    refTable: string = "dataTable";


    get loadingText()
    {
        return this.$t("Loading..");
    }
    /** get the table headers */
    get headers() {
        return this.tableHeaders.filter(x => x.show);
    }

    get selectedAll() {
        return this.tableHeaders.filter(x => !x.show).length == 0
    }

    set selectedAll(val) {
        if(val) {
            this.tableHeaders.map(x => x.show = val);
        }        
    }

    /** format values */
    formatValues(type, val) {
        switch(type) {
            case 'boolean':
                return (val == true) ? 'Yes' : 'No';
            case 'date':
                return (val) ? this.$services.format.formatDate(val): '';
            default:
                return val;
        }
    }

    /** Export to excel fns. */
  _btnExport() {
    let expotableItems: any = [];
    let defaultSheetName = "Sheet1";
    let defaultFileName = "Report";

    let expotableFields = this.headers.map(({ value, text, type }) => ({
      value,
      text,
      type
    }));

    // @ts-ignore
    let filteredItems = this.$refs[this.refTable].$children[0].filteredItems;

    // Select items with exportable true
    expotableItems = filteredItems.map(o =>
      expotableFields.reduce((acc, curr) => {
        acc[curr.text] = curr.value in o ? this.formatValues(curr.type, o[curr.value]) : "";
        return acc;
      }, {})
    );

    let fileName = `${this.filename || defaultFileName} [${moment().format(
      "DD-MM-YYYY"
    )}]`;

    // Export to excel
    if (expotableItems) {
      var sheet1 = XLSX.utils.json_to_sheet(expotableItems);
      var wb = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, sheet1, defaultSheetName);
      XLSX.writeFile(wb, `${fileName}.csv`);
    }
  }

}

